export enum PlayerPositionEnum {
  Goalkeeper = "GOALKEEPER",
  Defender = "DEFENDER",
  Midfielder = "MIDFIELDER",
  Forward = "FORWARD",
  Substitute = "SUBSTITUTE",
}
